'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var pobbleUser = require('pobble-components/dist/pobble-user');
var subscriptions = require('pobble-components/dist/subscriptions');
var injectSheet = require('react-jss');
var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var jssMixins = require('pobble-components/dist/jss-mixins');
var _slicedToArray = require('@babel/runtime/helpers/slicedToArray');
var Button = require('pobble-components/dist/button');
var setup = require('pobble-components/dist/setup');
var classNames = require('classnames');
var reactFontawesome = require('@fortawesome/react-fontawesome');
var faCheckCircle = require('@fortawesome/pro-solid-svg-icons/faCheckCircle');
var api = require('pobble-components/dist/api');
var pupils = require('pobble-components/dist/subscriptions/pupils.gif');
var Cookies = require('js-cookie');
var cookies = require('pobble-components/dist/cookies');
var _extends = require('@babel/runtime/helpers/extends');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var modal = require('pobble-components/dist/modal');
var faExclamationTriangle = require('@fortawesome/pro-solid-svg-icons/faExclamationTriangle');
var errorHandler = require('pobble-components/dist/error-handler');
var faCrown = require('@fortawesome/pro-solid-svg-icons/faCrown');
var THEME = require('pobble-components/dist/theme');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var injectSheet__default = /*#__PURE__*/_interopDefaultLegacy(injectSheet);
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
var _slicedToArray__default = /*#__PURE__*/_interopDefaultLegacy(_slicedToArray);
var Button__default = /*#__PURE__*/_interopDefaultLegacy(Button);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);
var pupils__default = /*#__PURE__*/_interopDefaultLegacy(pupils);
var Cookies__default = /*#__PURE__*/_interopDefaultLegacy(Cookies);
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);
var THEME__default = /*#__PURE__*/_interopDefaultLegacy(THEME);

function ownKeys$4(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$4(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$4(Object(source), !0).forEach(function (key) { _defineProperty__default["default"](target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$4(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var styles$3 = {
  subscriptionRequiredHolder: _objectSpread$4(_objectSpread$4({}, jssMixins.fullVHExceptHeader), {}, {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '40px',
    '& > *': {
      maxWidth: '820px'
    }
  })
};

var SubscriptionInspector = function SubscriptionInspector(_ref) {
  var classes = _ref.classes,
      children = _ref.children,
      policy = _ref.policy,
      renderWhenRestricted = _ref.renderWhenRestricted;

  var _useMe = pobbleUser.useMe(),
      me = _useMe.me;

  var currentPolicy = policy(me);
  if (!currentPolicy.restricted) return children;
  if (renderWhenRestricted) return renderWhenRestricted({
    plan: currentPolicy.plan
  });
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: classes.subscriptionRequiredHolder
  }, /*#__PURE__*/React__default["default"].createElement(subscriptions.SubscriptionRequired, {
    policy: currentPolicy
  }));
};

var inspector = injectSheet__default["default"](styles$3)(SubscriptionInspector);

function ownKeys$3(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$3(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$3(Object(source), !0).forEach(function (key) { _defineProperty__default["default"](target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$3(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var currencyMap = {
  AUD: 'A$',
  NZD: 'NZ$',
  USD: '$',
  GBP: '£'
};

var UpgradeButton = function UpgradeButton(_ref) {
  var trigger = _ref.trigger;
  return /*#__PURE__*/React__default["default"].createElement(Button__default["default"], {
    className: "metrics__subscription_modal ".concat(trigger ? "metrics__subscription_modal--".concat(trigger) : ''),
    action: function action() {
      window.location = "".concat(setup.URLS.ACCOUNT, "/membership").concat(trigger ? "?from=".concat(trigger) : '');
    },
    tall: true
  }, "Browse subscription options");
};

var pointStyles = function pointStyles(_ref2) {
  var COLORS = _ref2.COLORS;
  return {
    point: {
      display: 'flex',
      '& p': {
        margin: '0'
      },
      '& > svg': {
        color: COLORS.BLUE.NORMAL,
        fontSize: '18px',
        marginRight: '10px'
      }
    }
  };
};

var Point = injectSheet__default["default"](pointStyles)(function (_ref3) {
  var children = _ref3.children,
      classes = _ref3.classes;
  return /*#__PURE__*/React__default["default"].createElement("li", {
    className: classes.point
  }, /*#__PURE__*/React__default["default"].createElement(reactFontawesome.FontAwesomeIcon, {
    icon: faCheckCircle.faCheckCircle
  }), /*#__PURE__*/React__default["default"].createElement("p", null, children));
});

var styles$2 = function styles(_ref4) {
  var FONT_SIZES = _ref4.FONT_SIZES;
  return {
    container: {
      fontSize: '14px',
      '& button': {
        width: '240px',
        display: 'inline-flex',
        justifyContent: 'center'
      },
      '@media (min-width: 451px)': {
        display: 'flex',
        flexDirection: 'row-reverse',
        alignItems: 'center',
        '& > *': {
          width: '50%'
        }
      }
    },
    pitch: {
      textAlign: 'center',
      '@media (min-width: 451px)': {
        padding: '40px 10px 40px 38px'
      },
      '@media (min-width: 769px)': {
        padding: '40px 0 40px 40px'
      },
      '& h2': _objectSpread$3(_objectSpread$3({}, FONT_SIZES.HEADING_MEDIUM.STYLE), {}, {
        margin: '0 0 14px',
        '@media (min-width: 769px)': _objectSpread$3({}, FONT_SIZES.HEADING_BIG.STYLE)
      }),
      '& p': {
        margin: '0'
      },
      '& img': {
        display: 'block',
        maxWidth: '100%',
        height: 'auto',
        marginBottom: '24px',
        '@media (min-width: 768px)': {
          marginBottom: '32px'
        }
      },
      '& button': {
        margin: '28px 0 0',
        display: 'none',
        '@media (min-width: 451px)': {
          display: 'inline-flex'
        }
      }
    },
    description: {
      borderTop: '1px solid #ececec',
      paddingTop: '24px',
      marginTop: '24px',
      '@media (min-width: 451px)': {
        borderTop: 'none',
        borderRight: '1px solid #ececec',
        margin: '0',
        padding: '20px 40px 20px 0'
      },
      '& > p': {
        margin: '24px 0'
      }
    },
    points: {
      listStyle: 'none',
      margin: '24px 0',
      padding: '0',
      '@media (min-width: 451px)': {
        borderTop: 'none',
        margin: '30px 0'
      },
      '& li': {
        marginTop: '16px',
        '&:first-child': {
          marginTop: '0'
        }
      }
    },
    buttonHolder: {
      display: 'flex',
      justifyContent: 'center',
      margin: '40px 0 0',
      '@media (min-width: 451px)': {
        display: 'none'
      }
    }
  };
};

var SubscriptionRequired = function SubscriptionRequired(_ref5) {
  var classes = _ref5.classes,
      className = _ref5.className;

  var _useState = React.useState(null),
      _useState2 = _slicedToArray__default["default"](_useState, 2),
      priceData = _useState2[0],
      setPriceData = _useState2[1];

  var price = React.useMemo(function () {
    if (!priceData) return null;
    return "".concat(currencyMap[priceData.subscription_currency]).concat(parseInt(priceData.subscription_prices.annual_per_month['pobble_moderation']));
  }, [priceData]);

  var _useContext = React.useContext(subscriptions.SubscriptionContext),
      subsDialogState = _useContext.subsDialogState;

  React.useEffect(function () {
    api.apiClient.get('/v3/me', {
      params: {
        include: 'account.subscription_currency,account.subscription_prices'
      }
    }).then(function (res) {
      return setPriceData(res.data.account);
    });
  }, []);
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: classNames__default["default"](classes.container, className)
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: classes.pitch
  }, /*#__PURE__*/React__default["default"].createElement("img", {
    src: pupils__default["default"],
    width: "453",
    height: "224",
    alt: "Pupils"
  }), /*#__PURE__*/React__default["default"].createElement("h2", null, subsDialogState.title ? subsDialogState.title : 'You need a Pobble subscription to do that'), /*#__PURE__*/React__default["default"].createElement("p", null, "Subscription plans start from just ", price, "/month."), /*#__PURE__*/React__default["default"].createElement(UpgradeButton, {
    trigger: subsDialogState.trigger
  })), /*#__PURE__*/React__default["default"].createElement("div", {
    className: classes.description
  }, /*#__PURE__*/React__default["default"].createElement("p", null, "With a Pobble subscription you can present all premium lessons and resource types, including:"), /*#__PURE__*/React__default["default"].createElement("ul", {
    className: classes.points
  }, /*#__PURE__*/React__default["default"].createElement(Point, null, "Pobble 365 +"), /*#__PURE__*/React__default["default"].createElement(Point, null, "Theme-based, curriculum mapped lessons"), /*#__PURE__*/React__default["default"].createElement(Point, null, "Quick writes/Lesson starters"), /*#__PURE__*/React__default["default"].createElement(Point, null, "Literacy through sport"), /*#__PURE__*/React__default["default"].createElement(Point, null, "Pobble news"), /*#__PURE__*/React__default["default"].createElement(Point, null, "Success criteria/Word banks"), /*#__PURE__*/React__default["default"].createElement(Point, null, "Exemplar texts")), /*#__PURE__*/React__default["default"].createElement("p", null, "You can also edit and share unlimited Pobble content through printing/pdf, creating a lesson link (for 3rd party applications) and through Pobble's pupil tools."), /*#__PURE__*/React__default["default"].createElement("p", null, "You'll also be able to access our exemplification materials for online writing moderation.")), /*#__PURE__*/React__default["default"].createElement("div", {
    className: classes.buttonHolder
  }, /*#__PURE__*/React__default["default"].createElement(UpgradeButton, {
    trigger: subsDialogState.trigger
  })));
};

var SubscriptionRequired$1 = injectSheet__default["default"](styles$2)(SubscriptionRequired);

function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$2(Object(source), !0).forEach(function (key) { _defineProperty__default["default"](target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var Dialogs = function Dialogs(_ref) {
  var me = _ref.me;

  var _useContext = React.useContext(subscriptions.SubscriptionContext),
      subsDialogState = _useContext.subsDialogState,
      setSubsDialogState = _useContext.setSubsDialogState;

  var dueInvoiceHasBeenClosedCookie = Cookies__default["default"].get('SUBSCRIPTIONS:DUE_INVOICE_DIALOG_CLOSED');
  var dueInvoiceHasBeenClosedTimes = !dueInvoiceHasBeenClosedCookie ? 0 : parseInt(dueInvoiceHasBeenClosedCookie);
  var dueInvoiceBlocked = dueInvoiceHasBeenClosedTimes >= 3;
  /**
   * Don't show due invoice modal on the first user session
   *   to unblock normal onboarding and not overwhelm
   *   user with tons of modals
   */

  var _useState = React.useState(!cookies.FIRST_SESSION.get() && me.account.individual_subscription.due_invoice && window.location.href.indexOf('/membership') === -1 && (!Cookies__default["default"].get('SUBSCRIPTIONS:DUE_INVOICE_DIALOG_SEEN') || dueInvoiceBlocked)),
      _useState2 = _slicedToArray__default["default"](_useState, 2),
      dueInvoiceOpen = _useState2[0],
      setDueInvoiceOpen = _useState2[1];

  dueInvoiceOpen && Cookies__default["default"].set('SUBSCRIPTIONS:DUE_INVOICE_DIALOG_SEEN', true, _objectSpread$2(_objectSpread$2({}, setup.COOKIE_SETTINGS), {}, {
    expires: 1
  }));
  return /*#__PURE__*/React__default["default"].createElement(React.Fragment, null, /*#__PURE__*/React__default["default"].createElement(subscriptions.SubscriptionDueInvoiceDialog, {
    blocked: dueInvoiceBlocked,
    requestClose: function requestClose() {
      Cookies__default["default"].set('SUBSCRIPTIONS:DUE_INVOICE_DIALOG_CLOSED', dueInvoiceHasBeenClosedTimes + 1, _objectSpread$2(_objectSpread$2({}, setup.COOKIE_SETTINGS), {}, {
        expires: 10
      }));
      setDueInvoiceOpen(false);
    },
    isOpen: dueInvoiceOpen
  }), /*#__PURE__*/React__default["default"].createElement(subscriptions.SubscriptionRequiredDialog, {
    requestClose: function requestClose() {
      return setSubsDialogState(_objectSpread$2(_objectSpread$2({}, subsDialogState), {}, {
        open: false
      }));
    },
    isOpen: subsDialogState.open
  }));
};

var dialogs = pobbleUser.withMe(Dialogs);

var _excluded = ["classes", "blocked"];

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1(Object(source), !0).forEach(function (key) { _defineProperty__default["default"](target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var styles$1 = function styles(_ref) {
  var COLORS = _ref.COLORS,
      FONT_SIZES = _ref.FONT_SIZES;
  return {
    titleIcon: {
      margin: '0 8px 0 0',
      color: COLORS.TEXT.LIGHT_GREY.NORMAL
    },
    modalContent: _objectSpread$1({
      padding: '40px 20px'
    }, FONT_SIZES.BODY_LARGE.STYLE),
    overlay: {
      zIndex: '9999'
    },
    list: {
      margin: '24px 0',
      padding: '0 0 0 16px',
      '& > li': {
        marginTop: '24px',
        '&:first-child': {
          margin: '0'
        }
      }
    }
  };
};

var DueInvoiceDialog = function DueInvoiceDialog(_ref2) {
  var classes = _ref2.classes,
      blocked = _ref2.blocked,
      props = _objectWithoutProperties__default["default"](_ref2, _excluded);

  return /*#__PURE__*/React__default["default"].createElement(modal.Modal, _extends__default["default"]({
    overlayClassName: classes.overlay,
    closeButton: !blocked
  }, props), /*#__PURE__*/React__default["default"].createElement(modal.ModalHeader, null, /*#__PURE__*/React__default["default"].createElement("span", {
    className: classes.title
  }, /*#__PURE__*/React__default["default"].createElement(reactFontawesome.FontAwesomeIcon, {
    className: classes.titleIcon,
    icon: faExclamationTriangle.faExclamationTriangle
  }), "We have not received your payment yet")), /*#__PURE__*/React__default["default"].createElement(modal.ModalContent, {
    className: classes.modalContent
  }, "You have an overdue payment. Please settle this today by one of the following methods:", /*#__PURE__*/React__default["default"].createElement("br", null), /*#__PURE__*/React__default["default"].createElement("ol", {
    className: classes.list
  }, /*#__PURE__*/React__default["default"].createElement("li", null, /*#__PURE__*/React__default["default"].createElement("strong", null, "Credit or debit card"), " - click \u201CMake my payment\u201D and select \u201CPayment methods\u201D to add or update your card details."), /*#__PURE__*/React__default["default"].createElement("li", null, /*#__PURE__*/React__default["default"].createElement("strong", null, "Bank transfer or cheque"), " - follow the instructions on the invoice that was emailed to you to pay by bank transfer or cheque.")), "If we do not receive your payment or a confirmation that a bank transfer or cheque has been sent, we may limit or cancel your account. Please email", ' ', /*#__PURE__*/React__default["default"].createElement("strong", null, "hello@pobble.com"), " with any questions."), /*#__PURE__*/React__default["default"].createElement(modal.ModalFooter, {
    alignRight: true,
    childrenGap: true
  }, !blocked && /*#__PURE__*/React__default["default"].createElement(Button__default["default"], {
    tall: true,
    simple: true,
    action: props.requestClose
  }, "Close"), /*#__PURE__*/React__default["default"].createElement(Button__default["default"], {
    tall: true,
    href: "".concat(setup.URLS.ACCOUNT, "/membership")
  }, "Make my payment")));
};

var dueInvoiceDialog = injectSheet__default["default"](styles$1)(DueInvoiceDialog);

var styles = {
  modal: {
    zIndex: '1000'
  },
  overlay: {
    zIndex: '9999'
  },
  content: {
    maxWidth: '732px',
    padding: '50px 38px 40px 38px',
    '@media (min-width: 451px)': {
      padding: '40px'
    },
    '@media (min-width: 769px)': {
      padding: '60px',
      maxWidth: '880px'
    }
  }
};

var SubscriptionRequiredDialog = function SubscriptionRequiredDialog(_ref) {
  var classes = _ref.classes,
      isOpen = _ref.isOpen,
      policy = _ref.policy,
      requestClose = _ref.requestClose;
  return /*#__PURE__*/React__default["default"].createElement(modal.Modal, {
    overlayClassName: classes.overlay,
    className: classes.modal,
    isOpen: isOpen,
    requestClose: requestClose,
    closeButton: true
  }, /*#__PURE__*/React__default["default"].createElement(modal.ModalContent, {
    legacy: true,
    className: classes.content
  }, /*#__PURE__*/React__default["default"].createElement(SubscriptionRequired$1, {
    policy: policy
  })));
};

var subscriptionRequiredDialog = injectSheet__default["default"](styles)(SubscriptionRequiredDialog);

var goToSelfServicePortal = function goToSelfServicePortal() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return api.apiClient.get('/v3/me/subscriptions/chargebee_self_serve_portal_url').then(function (res) {
    options.beforeRedirect && options.beforeRedirect(res.data.url);
    window.location = res.data.url;
  })["catch"](errorHandler.errorHandler);
};

var checkoutPlan = function checkoutPlan(plan, params) {
  return api.apiClient.get("/v3/me/subscriptions/".concat(plan), {
    params: params
  }).then(function (res) {
    return window.location = res.data.url;
  })["catch"](errorHandler.errorHandler);
};

var useTimeTillEndPeriod = function useTimeTillEndPeriod(me) {
  var timeTillEndPeriod = React.useMemo(function () {
    var endPeriodString = me.account.individual_subscription.period_end;
    if (typeof endPeriodString !== 'string') return null;
    var endPeriodDate = new Date(endPeriodString);
    return endPeriodDate.getTime() - Date.now();
  }, [me]);
  return timeTillEndPeriod;
};

var crownStyles = {
  crown: function crown(_ref) {
    var accent = _ref.accent;
    return {
      fontSize: '10px',
      color: !accent ? THEME__default["default"].COLORS.TEXT.LIGHT_GREY.NORMAL : THEME__default["default"].COLORS.YELLOW.NORMAL
    };
  }
};
var SubsCrown = injectSheet__default["default"](crownStyles)(function (_ref2) {
  var classes = _ref2.classes,
      className = _ref2.className,
      styles = _ref2.styles;
  return /*#__PURE__*/React__default["default"].createElement(reactFontawesome.FontAwesomeIcon, {
    className: classNames__default["default"](classes.crown, className),
    styles: styles,
    icon: faCrown.faCrown
  });
});

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty__default["default"](target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var useSubscriptionDialog = function useSubscriptionDialog() {
  var context = React.useContext(subscriptions.SubscriptionContext);
  var setSubsDialogState = context.setSubsDialogState;
  return {
    showSubscriptionDialog: function showSubscriptionDialog(options) {
      return setSubsDialogState(_objectSpread({
        open: true
      }, options));
    }
  };
};
var useSubscriptionPolicy = function useSubscriptionPolicy(check) {
  var _useMe = pobbleUser.useMe(),
      me = _useMe.me;

  var context = React.useContext(subscriptions.SubscriptionContext);
  if (!context) return {
    restricted: false
  };
  var setSubsDialogState = context.setSubsDialogState;
  var policy = check(me.account.subscription_policy);
  return {
    restricted: policy.restricted,
    showDialog: function showDialog(options) {
      return setSubsDialogState(_objectSpread({
        open: true
      }, options));
    }
  };
};
/**
 * Subscription policy and feature counters are tightly coupled
 *  whenever particular feature counter reaches the limit
 *  we need to update a subscription policy
 */

var useFeatureCounter = function useFeatureCounter(featureCounterName, subscriptionPolicySelector) {
  var _useMe2 = pobbleUser.useMe(),
      updateMe = _useMe2.updateMe;

  var sp = useSubscriptionPolicy(subscriptionPolicySelector);

  var featureCounter = function featureCounter() {
    return api.apiClient.post("v3/me/subscriptions/increment_counter", {
      counter_type: featureCounterName
    }).then(function (res) {
      if (res.data.limit_just_reached) {
        /**
         * When feature counter reaches the limit we need to update
         *  subscription policy on the user level
         */
        updateMe(function (me) {
          var meCopy = _objectSpread(_objectSpread({}, me), {}, {
            account: _objectSpread(_objectSpread({}, me.account), {}, {
              subscription_policy: _objectSpread({}, me.account.subscription_policy)
            })
          });

          subscriptionPolicySelector(meCopy.account.subscription_policy).restricted = true;
          return meCopy;
        });
      }
    })["catch"](errorHandler.errorHandler);
  };

  return [featureCounter, sp];
};
var SubscriptionPolicy = function SubscriptionPolicy(_ref) {
  var children = _ref.children,
      policy = _ref.policy;
  var sp = useSubscriptionPolicy(policy);
  return children(sp);
};

var SubscriptionContext = /*#__PURE__*/React.createContext(null);

var SubscriptionProvider = function SubscriptionProvider(_ref) {
  var children = _ref.children;

  var _useMe = pobbleUser.useMe(),
      me = _useMe.me;

  var _useState = React.useState({
    open: false,
    policy: null,
    trigger: null
  }),
      _useState2 = _slicedToArray__default["default"](_useState, 2),
      subsDialogState = _useState2[0],
      setSubsDialogState = _useState2[1];

  var value = React.useMemo(function () {
    return {
      subsDialogState: subsDialogState,
      setSubsDialogState: setSubsDialogState
    };
  }, [subsDialogState, setSubsDialogState]);
  return !me ? children : /*#__PURE__*/React__default["default"].createElement(SubscriptionContext.Provider, {
    value: value
  }, children, /*#__PURE__*/React__default["default"].createElement(subscriptions.SubscriptionDialogs, null));
};

exports.SubsCrown = SubsCrown;
exports.SubscriptionContext = SubscriptionContext;
exports.SubscriptionDialogs = dialogs;
exports.SubscriptionDueInvoiceDialog = dueInvoiceDialog;
exports.SubscriptionInspector = inspector;
exports.SubscriptionPolicy = SubscriptionPolicy;
exports.SubscriptionProvider = SubscriptionProvider;
exports.SubscriptionRequired = SubscriptionRequired$1;
exports.SubscriptionRequiredDialog = subscriptionRequiredDialog;
exports.checkoutPlan = checkoutPlan;
exports.goToSelfServicePortal = goToSelfServicePortal;
exports.useFeatureCounter = useFeatureCounter;
exports.useSubscriptionDialog = useSubscriptionDialog;
exports.useSubscriptionPolicy = useSubscriptionPolicy;
exports.useTimeTillEndPeriod = useTimeTillEndPeriod;
//# sourceMappingURL=index.js.map



// WEBPACK FOOTER //
// /codebuild/output/src1478882582/src/pobble-app/client/~/pobble-components/dist/subscriptions/index.js